export default __webpack_public_path__ + "static/media/graph-line-up.a8a3efd3.svg";